import { gql } from '@apollo/client';

const QUERIES = {
  GET_LOGIN_OPERATION: gql`
    query login(
      $email: String!
      $password: String!
      $recaptchaVersion: RecaptchaVersion!
      $recaptchaToken: String!
      $brand: BillingSystem
      $deviceId: String
    ) {
      login(
        email: $email
        password: $password
        recaptchaVersion: $recaptchaVersion
        recaptchaToken: $recaptchaToken
        brand: $brand
        deviceId: $deviceId
      ) {
        accessToken
        accessTokenExpiresIn
        refreshToken
        refreshTokenExpiresIn
        statusCode
        passwordResetToken
        numberOfAuthenticationAttemptsRemaining
        isION
        isR6
        mfaForced
        offlineToken
        mfaToken
        otpDelivery
        biometricOptedIn
        otpUuid
      }
    }
  `,
  GET_ACCOUNT_TYPE: gql`
    query accountType {
      accountType {
        postpay
        prepay
      }
    }
  `,
  VALIDATE_MFA_OTP: gql`
    mutation validateMFAOTP($uuid: String!, $otp: String!, $operation: MFATokenOperation!) {
      validateMFAOTP(uuid: $uuid, otp: $otp, operation: $operation) {
        mfaToken
        deviceId
      }
    }
  `,
  SEND_MFA_OTP: gql`
    mutation sendMFAOTP($username: String, $operation: MFATokenOperation!) {
      sendMFAOTP(username: $username, operation: $operation) {
        uuid
        deliveryMethod
        mfaForced
      }
    }
  `,
};

export default QUERIES;

export const getLoginOperation = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_LOGIN_OPERATION,
    variables,
  });
  return data;
};

export const getAccountType = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.query({
    query: QUERIES.GET_ACCOUNT_TYPE,
    variables,
  });
  return data;
};

export const validateMfaOtp = async ({ graphql, otp, otpUuid, operation }) => {
  const data = await graphql.mutate({
    mutation: QUERIES.VALIDATE_MFA_OTP,
    variables: {
      otp,
      uuid: otpUuid,
      operation,
    },
  });
  return data;
};

export const sendMfaOtp = async ({ graphql, username, operation }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.SEND_MFA_OTP,
    variables: {
      username,
      operation,
    },
  });
  return data;
};
